/* Componente per far tornare nel menù il percorso scelto */
import React from 'react';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import '../List/ItemStyle.css'
import ShowMezzi from './RenderMezzi'
import ShowDettagli from './ShowDettagli'
import {switchMezziImage} from './SwitchMezziImage'
import calcoloPercorsoImage from '../SelectPathComponent/Calcolodelpercorso.svg'
import { connect } from 'react-redux';
import {selectNewIndex} from '../../redux'
import {selectNewTicketPosition} from '../../redux'
import {convertOra} from './TimeFunction'
import arrowDown from './arrowDown.svg'
import arrowUp from './arrowUp.svg'
import { Trans } from 'react-i18next';
import convertData from './DateFunction';
import moment from 'moment';

function RenderRow(props){
  const itinerario = props.item
  const legs = itinerario.legs;
  const dataViaggio = convertData(itinerario.startTime).replaceAll("/","-")
  
  let time = parseInt(itinerario.duration / 60)
  var hours = Math.floor(time /60)
  var minutes = time % 60
  const [open, setOpen] = React.useState(props.stato[props.index]);
  const [openDiv, setOpenDiv] = React.useState(false)
 
  const handleClick = () => {
    props.selectIndex(props.index)
    props.callback(props.index);
    setOpen(!open);
 
  };
  //funzione per aprire il div dal button DETTAGLI
const apriDiv = () =>{
 setOpenDiv(!openDiv)
};

//funzione per visualizzare le biglietterie
const showTicket = () =>{
  props.positionTicket([legs[0].from.lat,legs[0].from.lon])
}

const carOrWalk = (tipo) => {
  switch (tipo.mode) {
    case 'WALK':
      
      return <DirectionsWalkIcon style={{fontSize: '14px'}}/>
    case 'CAR': 
      return<DirectionsCarIcon style={{fontSize: '14px'}}/>
    default:
        return <DirectionsWalkIcon style={{fontSize: '14px'}}/>
  }
}
//lista percorsi
  return (
    <div className={"lista"}>
  
    <div onClick={handleClick} className="itemContainer" >
      <div className={"firstBox"}>
        <div className={"ImageType"}>
          
          {/*switchMezziImage(props.mode.split(",")[0])*/}
          <img src={calcoloPercorsoImage} alt="Calcolo" className={"calcoloPercorsoImage"}></img>
          
        </div>
        <div className={"data-ora"}>
          {convertOra(itinerario.startTime) + "  -  " + convertOra(itinerario.endTime)} ({dataViaggio})
        </div>
    
        <div className={"tempo"}>
              {hours + " h " + minutes + " min"}
        </div>
      </div>
      <div className={"secondBox"}>
      { (legs.length > 0) ? <div className={"boxMezzi"}>
      {legs.map((item, index) => (
        <ShowMezzi key={index} data={item} index={index} tot={legs.length}/>
        ))}
      </div> : null}
      </div>
    </div>
    { 
    
    (/* convertData(props.dataPartenza).replaceAll("/","-") !== dataViaggio*/moment(props.dataPartenza,"MM/DD/YYYY").isSame(moment(dataViaggio, "DD-MM-YYYY")) ||  props.dataPartenza === undefined) ? null : <div className={"alertViaggio"}><Trans>Il Giorno di partenza è diverso dal giorno selezionato</Trans></div>  }
    
    
    <div className={props.stato ? "visible" : "hidden"}>
     { (legs.length > 1) ? <div className={"dettagli"}>
      
      {convertOra(legs[0].to.departure) } da {legs[0].to.name}
      <div className={"walkText"}>
      {carOrWalk(legs[0])}{parseInt(itinerario.walkTime / 60) } min
      </div>
      {/*<button className={"showTicket"} onClick={showTicket}><Trans>Visualizza biglietterie</Trans></button>*/}

      <button className={"buttonDettagli"} onClick={apriDiv} >
      <img className={"arrowImage"} style={{paddingTop: '2px'}} src={ openDiv ? arrowUp : arrowDown } alt="Dettagli percorso" title="Dettagli percorso"></img>
        {/*<Trans>DETTAGLI</Trans>*/}</button>
      </div> : <div className={"dettagli"}>   <button className={"buttonDettagli"} onClick={apriDiv} >
      <img className={"arrowImage"} style={{paddingTop: '2px'}} src={ openDiv ? arrowUp : arrowDown } alt="Dettagli percorso" title="Dettagli percorso"></img>
      {/*<Trans>DETTAGLI</Trans>*/}</button>
      </div> }
        {openDiv ? <div className={"openDiv"}> <ShowDettagli realTime={props.realTime} data={itinerario}/> </div> : <div className={"closeDiv"}/>}
 
    </div>
  </div>
  )

}

const mapStateToProps = state => {
  return {
    indexData: state.index,
    positionTicket: state.positionTicket
  }
}
const mapDispatchToProps = dispatch => {
  return {
    selectIndex: (index) => dispatch(selectNewIndex(index)),
    positionTicket: (positionTicket) => dispatch(selectNewTicketPosition(positionTicket))
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(RenderRow)